import { Phone, EnvelopeSimple, WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_URL } from "@/App";

const FacebookIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#1877F2" />
    <path
      fill="#FFFFFF"
      d="M16.8 15.5l.6-3.9h-3.7V9.1c0-1.1.5-2.1 2.2-2.1h1.7V3.6s-1.6-.3-3.1-.3c-3.1 0-5.2 1.9-5.2 5.4v2.9H5.5v3.9h3.8v9.4c.8.1 1.5.2 2.3.2s1.6-.1 2.3-.2v-9.4h3.0z"
      transform="scale(0.92) translate(1,0.4)"
    />
  </svg>
);

const InstagramIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <defs>
      <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#fdf497" />
        <stop offset="5%" stopColor="#fdf497" />
        <stop offset="45%" stopColor="#fd5949" />
        <stop offset="60%" stopColor="#d6249f" />
        <stop offset="90%" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-grad)" />
    <path
      fill="#FFFFFF"
      d="M12 4.2c2.6 0 2.9 0 3.9.1 1 .1 1.5.2 1.9.4.5.2.8.4 1.2.8.4.4.6.7.8 1.2.2.4.3.9.4 1.9.1 1 .1 1.3.1 3.9s0 2.9-.1 3.9c-.1 1-.2 1.5-.4 1.9-.2.5-.4.8-.8 1.2-.4.4-.7.6-1.2.8-.4.2-.9.3-1.9.4-1 .1-1.3.1-3.9.1s-2.9 0-3.9-.1c-1-.1-1.5-.2-1.9-.4-.5-.2-.8-.4-1.2-.8-.4-.4-.6-.7-.8-1.2-.2-.4-.3-.9-.4-1.9-.1-1-.1-1.3-.1-3.9s0-2.9.1-3.9c.1-1 .2-1.5.4-1.9.2-.5.4-.8.8-1.2.4-.4.7-.6 1.2-.8.4-.2.9-.3 1.9-.4 1-.1 1.3-.1 3.9-.1M12 2.6c-2.6 0-3 0-4 .1-1 .1-1.7.2-2.3.5-.6.2-1.1.6-1.6 1-.5.5-.8 1-1 1.6-.3.6-.5 1.3-.5 2.3-.1 1-.1 1.4-.1 4s0 3 .1 4c.1 1 .2 1.7.5 2.3.2.6.6 1.1 1 1.6.5.5 1 .8 1.6 1 .6.3 1.3.5 2.3.5 1 .1 1.4.1 4 .1s3 0 4-.1c1-.1 1.7-.2 2.3-.5.6-.2 1.1-.6 1.6-1 .5-.5.8-1 1-1.6.3-.6.5-1.3.5-2.3.1-1 .1-1.4.1-4s0-3-.1-4c-.1-1-.2-1.7-.5-2.3-.2-.6-.6-1.1-1-1.6-.5-.5-1-.8-1.6-1-.6-.3-1.3-.5-2.3-.5-1-.1-1.4-.1-4-.1M12 7.4c-2.5 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6 4.6-2.1 4.6-4.6-2.1-4.6-4.6-4.6m0 7.6c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3m4.8-7.8c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1.5-1.1 1.1-1.1 1.1.5 1.1 1.1"
    />
  </svg>
);

const LinkedinIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <rect width="24" height="24" rx="3" fill="#0A66C2" />
    <path
      fill="#FFFFFF"
      d="M6.94 8.5v10.06H4.13V8.5h2.81zM5.5 4a1.64 1.64 0 1 1 0 3.28 1.64 1.64 0 0 1 0-3.28zm5.72 4.5v1.24h.04c.38-.72 1.3-1.48 2.68-1.48 2.87 0 3.4 1.89 3.4 4.35v5.95h-2.81v-5.28c0-1.26-.02-2.88-1.76-2.88-1.76 0-2.03 1.37-2.03 2.79v5.37H8.93V8.5h2.29z"
    />
  </svg>
);

const SOCIALS = [
  { icon: FacebookIcon, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61594924792414", testid: "footer-facebook-link" },
  { icon: InstagramIcon, label: "Instagram", href: "https://www.instagram.com/thermoglasspro", testid: "footer-instagram-link" },
  { icon: LinkedinIcon, label: "LinkedIn", href: "https://www.linkedin.com/company/146634883", testid: "footer-linkedin-link" },
];

const NAV = [
  { id: "how-it-works", label: "How It Works" },
  { id: "sectors", label: "Who It's For" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-400 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-4 h-4 bg-[#38BDF8]" />
            <span className="font-heading font-black tracking-tight text-lg text-white">
              THERMOGLASSPRO
            </span>
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-xs">
            Professional solar-control coating, applied to existing glass.
          </p>
          <p className="mt-5 text-sm leading-relaxed max-w-xs">
            Homeowner? The same coating works on apartments and villas.{" "}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-homeowners-link"
              className="text-[#38BDF8] hover:text-white transition-colors duration-150"
            >
              ask us on WhatsApp
            </a>
            .
          </p>
        </div>

        <div>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-slate-500 mb-6">
            Contact
          </p>
          <div className="space-y-4 text-sm">
            <a href="tel:+35679029089" data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-white transition-colors duration-150">
              <Phone size={16} className="text-[#38BDF8]" /> +356 7902 9089
            </a>
            <a href="mailto:contact@thermoglasspro.com" data-testid="footer-email-link" className="flex items-center gap-3 hover:text-white transition-colors duration-150">
              <EnvelopeSimple size={16} className="text-[#38BDF8]" /> contact@thermoglasspro.com
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 hover:text-white transition-colors duration-150">
              <WhatsappLogo size={16} className="text-[#25D366]" /> WhatsApp · fastest reply
            </a>
          </div>
          <p className="mt-8 font-mono text-xs tracking-[0.25em] uppercase text-slate-500 mb-4">
            Follow Us
          </p>
          <div className="flex items-center gap-4">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={s.testid}
                aria-label={s.label}
                className="w-10 h-10 flex items-center justify-center border border-slate-700 hover:border-slate-500 hover:-translate-y-0.5 transition-[border-color,transform] duration-150"
              >
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-slate-500 mb-6">
            Explore
          </p>
          <div className="space-y-4 text-sm">
            {NAV.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`footer-nav-${l.id}`}
                className="block hover:text-white transition-colors duration-150"
              >
                {l.label}
              </a>
            ))}
          </div>
          <p className="mt-8 font-mono text-xs text-slate-500 leading-relaxed">
            ThermoGlassPro
            <br />
            125 Cameron Street, Gżira, Malta
            <br />
            VAT no. 24325236
          </p>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-wrap gap-4 items-center justify-between font-mono text-xs text-slate-500">
          <span>© 2026 ThermoGlassPro. All rights reserved.</span>
          <span>Manufacturer data · optical performance to EN 410.</span>
          <a href="/privacy.html" data-testid="footer-privacy-link" className="hover:text-white transition-colors duration-150">
            Privacy policy
          </a>
          <a href="/terms.html" data-testid="footer-terms-link" className="hover:text-white transition-colors duration-150">
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
}
